module.exports = __webpack_public_path__ + "img/badge-box-red.eafc2e53.svg";